import { useContext } from "react";
import { VideosContext } from "@shapeable/ui";

export const useVideoPodcasts = () => (useContext(VideosContext) || []).filter(video => video?.type?.slug === 'podcast');